// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__OWlOi","choiceBoxes":"toolbarselects_choiceBoxes__2c8M0","simpleField":"toolbarselects_simpleField__3q3Ig"};